// import React from 'react'
// import './contact.css'
// import data from './data'

// const Contact = () => {
//   return (
   
//       <section id="contact" >
//      <h1 className="port-head" style={{textAlign:"center",
//       fontSize:"1.9rem",
//       fontWeight:"800",
//       color:"rgb(0,0,0)",
//       margin:"2rem 0"}}>GET IN TOUCH</h1>
  
//       <div className='contact-me'>
    
//       {data.map(
//   item => 
//   <a key={item.id}
//    href={item.link}
//     >{item.icon}
//   </a>
// )
//   }
//       </div>
//       </section>
    
//   )
// }

// export default Contact


import React from 'react';
import { AiOutlinePhone, AiOutlineSlack, AiOutlineWhatsApp, AiOutlineMail, AiOutlineLinkedin } from 'react-icons/ai';
import { FaGithub, FaLinkedin, FaMailBulk, FaSlack } from 'react-icons/fa';

// Define the contact data
const data = [
  { id:1, link:'', icon:<AiOutlineSlack/> },
  { id:2, link:'mailto: kashafabdullah01@gmail.com', icon:<AiOutlineMail/> },
  { id:3, link:'https://www.linkedin.com/in/kashaf-abdullah-482246207/', icon:<AiOutlineLinkedin/> },
];

// Define the Contact component
const Contact = () => {
  // Inline styles
  const sectionStyle = {
    textAlign: "center",
    fontFamily: "'Varela Round', sans-serif",
    padding: "2rem 0"
  };

  const headerStyle = {
    textAlign: "center",
    fontSize: "1.9rem",
    fontWeight: "800",
    color: "rgb(0, 0, 0)",
    margin: "2rem 0"
  };

  const contactMeStyle = {
    display: "flex",
    gap: "1rem",
    justifyContent: "center",
    margin: "3rem 3rem",
    fontFamily: "'Varela Round', sans-serif"
  };

  const contactLinkStyle = {
    width: "2.8rem",
    aspectRatio: "1/1",
    background: "var(--secondary)",
    color: "var(--white)",
    display: "grid",
    placeItems: "center",
    borderRadius: "10px",
    fontSize: "1.4rem",
    transition: "transform 0.3s, background-color 0.3s, color 0.3s"
  };

  const contactLinkHoverStyle = {
    backgroundColor: "var(--white)",
    color: "var(--secondary)",
    border:"1px solid var(--secondary)",
    transform: "translateX(-0.5rem)"
  }; const iconStyle={
    // backgroundColor: "var(--secondary)",
              fontSize: "20px",
              fontWeight: "800",
              color: "var(--secondary)",
              border: "2px solid var(--secondary)",
              borderRadius:"20%",
              margin:"0 1px",
              padding:"8px 10px"
             
  }

  return (
    <section id="contact" style={sectionStyle}>
      <h1 className='sec-title'>GET IN TOUCH</h1>
      <div className="logo-social-media" style={{ margin: "1rem 0" }}>
        
<a className='button-85' href="https://www.linkedin.com/in/kashaf-abdullah-482246207/" target="_blank" rel="noopener noreferrer"  style={iconStyle}>
      <FaLinkedin style={{position:"relative",bottom:"2px"}}/>
    </a>

    <a className='button-85' href="https://github.com/Kashaf-Abdullah/" target="_blank" rel="noopener noreferrer"  style={iconStyle}>
      <FaGithub style={{position:"relative",bottom:"2px"}}/>
    </a>

    <a className='button-85' href="mailto: kashafabdullah01@gmail.com" target="_blank" rel="noopener noreferrer"  style={iconStyle}>
      <FaMailBulk style={{position:"relative",bottom:"2px"}}/>
    </a>


    <a className='button-85' href="" target="_blank" rel="noopener noreferrer"  style={iconStyle}>
      <FaSlack style={{position:"relative",bottom:"2px"}}/>
    </a>
  
         </div>
    </section>
  );
};

export default Contact;
